import { useState } from "react";

export function useShowToastState() {
  return useState(false);
}
